import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Paper,
  TextField,
  CircularProgress,
  Container,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import AdminDashboard from "../../Admin/Dashboard/Dashboard";
import { BASE_URL } from "../../Api/ApiUrls";

const CustomersLoginHistoryTable = () => {
  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // ✅ Fetch Users (NOT flattening)
  const fetchLoginHistory = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${BASE_URL}/users/`);

      const users = Array.isArray(response.data)
        ? response.data
        : [response.data];

      setLoginHistory(users);
    } catch (error) {
      console.error("Error fetching login history:", error);
      toast.error("Failed to fetch login history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoginHistory();
  }, []);

  // ✅ Search Filter (user level)
  const filteredData = loginHistory.filter((user) =>
    user.username?.toLowerCase().includes(search.toLowerCase()) ||
    user.email?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <AdminDashboard />

      <Container sx={{ mt: 2 }}>
        <Box
          sx={{
            maxWidth: 1300,
            mx: "auto",
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: "#fff",
          }}
        >
          <Typography
            variant="h4"
            sx={{ textAlign: "center", color: "primary.main", mb: 2 }}
          >
            Customers Login History
          </Typography>

          {/* 🔍 Search */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <TextField
              label="Search by Username or Email"
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Type username or email..."
              size="small"
              sx={{ width: 300 }}
            />
          </Box>

          {/* 📊 Table */}
          <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {[
                    "S.No",
                    "Username",
                    "Email",
                    "Login Time(s)",
                    "Logout Time(s)",
                  ].map((head) => (
                    <TableCell
                      key={head}
                      sx={{
                        color: "white",
                        textAlign: "center",
                        fontSize: 16,
                        backgroundColor: "#1976d2",
                        top: 0,
                        zIndex: 2,
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredData.map((user, index) => (
                  <TableRow key={user.user_id}>
                    <TableCell sx={{ textAlign: "center" }}>
                      {index + 1}
                    </TableCell>

                    <TableCell sx={{ textAlign: "center" }}>
                      {user.username || "-"}
                    </TableCell>

                    <TableCell sx={{ textAlign: "center" }}>
                      {user.email || "-"}
                    </TableCell>

                    {/* ✅ Multiple Login Times */}
                    <TableCell sx={{ textAlign: "center" }}>
                      {user.log_history?.length > 0 ? (
                        user.log_history.map((log, i) => (
                          <div key={i}>
                            {new Date(log.login_time).toLocaleString()}
                          </div>
                        ))
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    {/* ✅ Multiple Logout Times */}
                    <TableCell sx={{ textAlign: "center" }}>
                      {user.log_history?.length > 0 ? (
                        user.log_history.map((log, i) => (
                          <div key={i}>
                            {log.logout_time
                              ? new Date(log.logout_time).toLocaleString()
                              : "-"}
                          </div>
                        ))
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </>
  );
};

export default CustomersLoginHistoryTable;